import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src", "width", "height", "alt"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 2,
  class: "overlap-icon"
}
const _hoisted_4 = { class: "hidden-visually" }
const _hoisted_5 = {
  key: 3,
  class: "overlap-icon"
}
const _hoisted_6 = { class: "hidden-visually" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcAvatar = _resolveComponent("NcAvatar")
  const _component_IconVideo = _resolveComponent("IconVideo")
  const _component_IconStar = _resolveComponent("IconStar")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["conversation-icon", [$options.themeClass, { offline: $props.offline }]]),
    style: _normalizeStyle({ '--icon-size': `${$props.size}px` })
  }, [
    (!$options.isOneToOne)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.iconClass)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["avatar icon", $options.iconClass])
              }, null, 2))
            : (_openBlock(), _createElementBlock("img", {
                key: $options.avatarUrl,
                src: $options.avatarUrl,
                width: $props.size,
                height: $props.size,
                alt: $props.item.displayName,
                class: "avatar icon",
                onError: _cache[0] || (_cache[0] = (...args) => ($setup.onError && $setup.onError(...args)))
              }, null, 40, _hoisted_1)),
          (!$props.hideUserStatus && $options.conversationType)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "conversation-icon__type",
                role: "img",
                "aria-hidden": "false",
                "aria-label": $options.conversationType.label
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent($options.conversationType.icon), {
                  size: $props.size * 0.3
                }, null, 8, ["size"]))
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_component_NcAvatar, {
          key: $props.item.token + ($setup.isDarkTheme ? '-dark' : '-light'),
          size: $props.size,
          user: $props.item.name,
          "disable-menu": $props.disableMenu,
          "display-name": $props.item.displayName,
          "preloaded-user-status": $options.preloadedUserStatus,
          "hide-status": $props.hideUserStatus,
          "verbose-status": $props.showUserOnlineStatus,
          class: "conversation-icon__avatar"
        }, null, 8, ["size", "user", "disable-menu", "display-name", "preloaded-user-status", "hide-status", "verbose-status"])),
    ($options.showCall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_IconVideo, {
            size: $props.size * 0.5,
            "fill-color": "#E9322D"
          }, null, 8, ["size"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString($options.t('spreed', 'Call in progress')), 1)
        ]))
      : ($options.showFavorite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_IconStar, {
              size: $props.size * 0.5,
              "fill-color": "#FFCC00"
            }, null, 8, ["size"]),
            _createElementVNode("span", _hoisted_6, _toDisplayString($options.t('spreed', 'Favorite')), 1)
          ]))
        : _createCommentVNode("", true)
  ], 6))
}